import { render, staticRenderFns } from "./costHelpSpa.vue?vue&type=template&id=3d687fb0&"
import script from "./costHelpSpa.vue?vue&type=script&lang=js&"
export * from "./costHelpSpa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d687fb0')) {
      api.createRecord('3d687fb0', component.options)
    } else {
      api.reload('3d687fb0', component.options)
    }
    module.hot.accept("./costHelpSpa.vue?vue&type=template&id=3d687fb0&", function () {
      api.rerender('3d687fb0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2UwmGIk7Rz01W/JS/comp/costHelpSpa.vue"
export default component.exports